//import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from '../animation/customAnimation';
import jQuery from "jquery";

const customAnmation = new CustomAnimation();

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

class Resources {
  init() {
    this.initPage();
    this.initParallax();
  }

  initPage = () => {

    // background
    jQuery('.header_background').css("background-image", "url("+ jQuery('.header_background').data('bg-image') +")");
    jQuery('.business_boost_background').css("background-image", "url("+ jQuery('.business_boost_background').data('bg-image') +")");
    jQuery('.contact_background').css("background-image", "url("+ jQuery('.contact_background').data('bg-image') +")");

    var searchParam = getUrlParameter('search');
    if(searchParam == "" || searchParam == false) {
      jQuery('.search_result').addClass('hide');
    }
    else  {
      jQuery('.search_result').removeClass('hide');
      $('html, body').scrollTop($("#business_boost").offset().top);
    }
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateBgImage('.business_boost_background', '.business_boost');
    customAnmation.animateHeaderImage('.header_background');
    customAnmation.animateText('.business_boost_text');
    customAnmation.animateGroup('.business_boost_button_holder');

    customAnmation.animateBgImage('.contact_background', '.contact');
    customAnmation.animateScaleDown('.contact_form');
    customAnmation.animateText('.contact_text');
  }
}

export default Resources;
